import React from 'react';
import type { LinkPreviewMedia } from '@/server/services/LinkPreview/LinkPreview.types';
import { Styles } from '@/styles/styles';
import styles from './TargetVideo.module.scss';

export interface TargetVideoProps {
  videoSrc?: string | null;
  videoSrcType?: LinkPreviewMedia['videoSrcType'];
}

export const TargetVideo: React.FC<TargetVideoProps> = ({ videoSrc, videoSrcType }) => {
  if (!videoSrc) {
    return null;
  }

  switch (videoSrcType) {
    case 'regular':
      return (
        <div key={videoSrc} className={styles.image}>
          <video src={videoSrc} />
        </div>
      );
    case 'embed':
      // eslint-disable-next-line
      const h = videoSrc.match('instagram.com') ? 570 : 280;
      return (
        <div key={videoSrc} className={styles.image}>
          <iframe src={videoSrc} width="100%" height={h} allow="autoplay" allowFullScreen />
        </div>
      );
    case 'html_embed':
      return (
        <iframe
          srcDoc={videoSrc}
          width="100%"
          height="690px"
          style={{ borderRadius: Styles.borderRadius }}
          allowFullScreen
        />
      );
    default:
      return null;
  }
};
